import { createFilterColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { filterStoreRepo } from 'components/Filters/FilterStore'
import FilterModal, {
  FilterGroup,
} from 'components/Filters/components/FilterModal'
import { RangeFilter } from 'components/Filters/fields/RangeFilter'
import { DateRangeFilterWithPresets } from 'components/Filters/fields/DateRangeFilterWithPresets'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { FilterIdentifier } from 'models/saved_view'
import { REBATE_ENROLLMENT_COLUMNS } from './rebateEnrollmentsColumnInfo'

export function RebateOfferEnrollmentsFilterset({
  filterIdentifier,
}: {
  filterIdentifier: FilterIdentifier
}) {
  const rebateEnrollmentsFilterStore =
    filterStoreRepo.getStore(filterIdentifier)
  const rebateEnrollmentFilterHelper = createFilterColumnHelper({
    columns: REBATE_ENROLLMENT_COLUMNS,
  })

  const statusOptions = [
    { label: 'Email Captured', value: 'email captured' },
    { label: 'Account Created', value: 'account created' },
    { label: 'Enrolled', value: 'enrolled' },
    { label: 'Claim Submitted', value: 'claim submitted' },
    { label: 'Claim Approved', value: 'claim approved' },
  ]

  return (
    <FilterModal
      identifier={filterIdentifier}
      store={rebateEnrollmentsFilterStore}
    >
      <FilterGroup title="Status">
        <SelectFilter
          {...rebateEnrollmentFilterHelper.retrieveProps('status')}
          options={statusOptions}
          filterStore={rebateEnrollmentsFilterStore}
        />
      </FilterGroup>

      <FilterGroup title="Claims">
        <RangeFilter
          {...rebateEnrollmentFilterHelper.retrieveProps('total_claims')}
          store={rebateEnrollmentsFilterStore}
        />
        <RangeFilter
          {...rebateEnrollmentFilterHelper.retrieveProps(
            'pending_validation_claims'
          )}
          store={rebateEnrollmentsFilterStore}
        />
        <RangeFilter
          {...rebateEnrollmentFilterHelper.retrieveProps('paid_claims')}
          store={rebateEnrollmentsFilterStore}
        />
        <RangeFilter
          {...rebateEnrollmentFilterHelper.retrieveProps('invalid_claims')}
          store={rebateEnrollmentsFilterStore}
        />
        <RangeFilter
          {...rebateEnrollmentFilterHelper.retrieveProps('unpaid_valid_claims')}
          store={rebateEnrollmentsFilterStore}
        />
      </FilterGroup>

      <FilterGroup title="Validated Data">
        <RangeFilter
          {...rebateEnrollmentFilterHelper.retrieveProps(
            'total_validated_units'
          )}
          store={rebateEnrollmentsFilterStore}
        />
        <RangeFilter
          {...rebateEnrollmentFilterHelper.retrieveProps(
            'total_validated_payout'
          )}
          store={rebateEnrollmentsFilterStore}
        />
      </FilterGroup>

      <FilterGroup title="Enrollment Date">
        <DateRangeFilterWithPresets
          {...rebateEnrollmentFilterHelper.retrieveProps('created')}
          filterStore={rebateEnrollmentsFilterStore}
        />
      </FilterGroup>
    </FilterModal>
  )
}
